import Vue from "vue";
import VueRouter from "vue-router";
import Home from "@/views/Home.vue";
import Login from "@/views/Login.vue";

import UserList from "@/views/user/UserList.vue";
import UserDetails from "@/views/user/UserDetails.vue";
import BankInformationList from "@/views/bank-information/BankInformationList.vue";

import AdminList from "@/views/admin/AdminList.vue";
import AdminDetails from "@/views/admin/AdminDetails.vue";
import ProfileList from "@/views/profile/ProfileList.vue";
import ProfileDetails from "@/views/profile/ProfileDetails.vue";

import EventList from "@/views/event/EventList.vue";
import EventDetails from "@/views/event/EventDetails.vue";
import EventBulkAnalysis from "@/views/event/BulkAnalysis.vue";
import EventCreate from "@/views/event/EventCreate.vue";
import EventBulkCreate from "@/views/event/EventBulkCreate.vue";
import AccreditationList from "@/views/accreditation/AccreditationList.vue";
// import AccreditationDetails from "@/views/accreditation/AccreditationDetails.vue";

import ClientList from "@/views/client/ClientList.vue";
import ClientDetails from "@/views/client/ClientDetails.vue";

import CreditorsList from "@/views/creditors-list/CreditorsList.vue";
import CreditorsInclude from "@/views/creditors-list/CreditorsListDetails.vue";
import CreditorsListImport from "@/views/creditors-list/CreditorsListImport.vue";


import EmployeeList from "@/views/employee/EmployeeList.vue";
import EmployeeDetails from "@/views/employee/EmployeeDetails.vue";


import ProceedingList from "@/views/proceedings/ProceedingList.vue";
import ProceedingDetails from "@/views/proceedings/ProceedingDetails.vue";

import LetterAnalysisList from "@/views/letter-analysis/LetterAnalysisList.vue";
import OtherProceedingList from "@/views/other-proceedings/OtherProceedingList.vue";
import OtherProceedingDetails from "@/views/other-proceedings/OtherProceedingDetails.vue";
import LetterAnalysisDetails from "@/views/letter-analysis/LetterAnalysisDetails.vue";
import CreditAnalysisList from "@/views/credit-analysis/CreditAnalysisList.vue";
import CreditAnalysisDetails from "@/views/credit-analysis/CreditAnalysisDetails.vue";

import PlanAdhesionList from "@/views/plan-adhesion/PlanAdhesionList.vue";
import PlanAdhesionDetails from "@/views/plan-adhesion/PlanAdhesionDetails.vue";
import RmaDashboard from "@/views/rma/RmaDashboard.vue";
import RmaCaseDetails from "@/views/rma/RmaCaseDetails.vue";
import RmaDocumentTypeList from "@/views/rma/RmaDocumentTypeList.vue";
import RmaQuestionTemplate from "@/views/rma/RmaQuestionTemplate.vue";
import RmaAudit from "@/views/rma/RmaAudit.vue";
import ProspectImportDetails from "@/views/prospect/ProspectImportDetails.vue";
import ProspectCases from "@/views/prospect/ProspectCases.vue";
import ProspectCaseDetails from "@/views/prospect/ProspectCaseDetails.vue";
import ProspectDeadlines from "@/views/prospect/ProspectDeadlines.vue";
import ProspectCompetition from "@/views/prospect/ProspectCompetition.vue";
import ProspectAdministrators from "@/views/prospect/ProspectAdministrators.vue";
import ProspectJudges from "@/views/prospect/ProspectJudges.vue";
import ProspectJudgeDetails from "@/views/prospect/ProspectJudgeDetails.vue";
import ProspectDashboard from "@/views/prospect/ProspectDashboard.vue";
import ProspectMeetings from "@/views/prospect/ProspectMeetings.vue";
import ProspectMetrics from "@/views/prospect/ProspectMetrics.vue";
import ProspectTrips from "@/views/prospect/ProspectTrips.vue";
import ProspectTripEditor from "@/views/prospect/ProspectTripEditor.vue";
import ProspectOffices from "@/views/prospect/ProspectOffices.vue";
import CompetitiveDashboard from "@/views/competitive/CompetitiveDashboard.vue";
import CompetitiveProcessList from "@/views/competitive/CompetitiveProcessList.vue";
import CompetitiveProcessDetails from "@/views/competitive/CompetitiveProcessDetails.vue";
import CompetitiveAssetList from "@/views/competitive/CompetitiveAssetList.vue";
import CompetitiveAssetDetails from "@/views/competitive/CompetitiveAssetDetails.vue";
import CompetitiveGroupList from "@/views/competitive/CompetitiveGroupList.vue";
import CompetitiveStageList from "@/views/competitive/CompetitiveStageList.vue";
import CompetitiveRegistrationList from "@/views/competitive/CompetitiveRegistrationList.vue";
import CompetitiveDataroom from "@/views/competitive/CompetitiveDataroom.vue";
import CompetitiveAuditTrail from "@/views/competitive/CompetitiveAuditTrail.vue";
import CompetitivePublicSession from "@/views/competitive/CompetitivePublicSession.vue";
import CompetitiveHomologation from "@/views/competitive/CompetitiveHomologation.vue";
import QgcList from "@/views/qgc/QgcList.vue";
import QgcDetails from "@/views/qgc/QgcDetails.vue";

import ClientDocList from "@/views/client-doc/ClientDocList.vue";
import ClientDocDetails from "@/views/client-doc/ClientDocDetails.vue";

import FaqList from "@/views/faq/FaqList.vue";
import ClientNewsList from "@/views/client-news/ClientNewsList.vue";
import FaqDetails from "@/views/faq/FaqDetails.vue";

import GeneralMeetingList from "@/views/general-meeting/GeneralMeetingList.vue";
import GeneralMeetingDetails from "@/views/general-meeting/GeneralMeetingDetails.vue";
import GeneralMeetingVoting from "@/views/general-meeting/GeneralMeetingVoting.vue";
import GeneralMeetingPresence from "@/views/general-meeting/GeneralMeetingPresence.vue";
import VotingScenarios from "@/views/general-meeting/VotingScenarios.vue";
import GeneralMeetingHomologations from "@/views/general-meeting/GeneralMeetingHomologations.vue";
import GeneralMeetingSubstitutions from "@/views/general-meeting/GeneralMeetingSubstitutions.vue";
import VotingList from "@/views/general-meeting/VotingList.vue";
import VotingDetails from "@/views/general-meeting/VotingDetails.vue";

import DistrictList from "@/views/district/DistrictList.vue";
import DistrictDetails from "@/views/district/DistrictDetails.vue";

import PostList from "@/views/post/PostList.vue";
import PostDetails from "@/views/post/PostDetails.vue";

import DynamicTextList from "@/views/dynamic-text/DynamicTextList.vue";
import DynamicTextDetails from "@/views/dynamic-text/DynamicTextDetails.vue";

import DynamicInfoList from "@/views/dynamic-info/DynamicInfoList.vue";
import DynamicInfoDetails from "@/views/dynamic-info/DynamicInfoDetails.vue";

import TemplateDocList from "@/views/template-doc/TemplateDocList.vue";
import TemplateDocDetails from "@/views/template-doc/TemplateDocDetails.vue";

import ProcuratorList from "@/views/procurator/ProcuratorList.vue";
import ProcuratorDetails from "@/views/procurator/ProcuratorDetails.vue";
import ProcurationTemplates from "@/views/procurator/ProcurationTemplates.vue";

import MostConsultedList from "@/views/most-consulted-process/MostConsultedList.vue";

import HomeBannerList from "@/views/home-banner/HomeBannerList.vue";
import HomeBannerDetails from "@/views/home-banner/HomeBannerDetails.vue";

import access from "@/common/access";


import ClientAdminList from "@/views/client-admins/ClientAdminList.vue";
import AuditLogList from "@/views/audit/AuditLogList.vue";
import EmailLogList from "@/views/email-log/EmailLogList.vue";
import CorrespondenceList from "@/views/correspondence/CorrespondenceList.vue";
import CreditCertificateList from "@/views/credit-certificate/CreditCertificateList.vue";
import CreditCertificateDetails from "@/views/credit-certificate/CreditCertificateDetails.vue";

import * as jwt from "jwt-decode";

function getStoredToken() {
  const rawToken = localStorage.getItem("token");

  if (!rawToken) return null;

  try {
    const parsed = JSON.parse(rawToken);

    if (parsed && parsed.token) return parsed.token;
    if (parsed && parsed.value && parsed.value.token) return parsed.value.token;
    if (typeof parsed === "string") return parsed;
  } catch (error) {
    return rawToken;
  }

  return rawToken;
}

function hasStoredRefreshToken() {
  const rawToken = localStorage.getItem("token");

  if (!rawToken) return false;

  try {
    const parsed = JSON.parse(rawToken);
    const tokenData = parsed && parsed.value && parsed.value.token ? parsed.value : parsed;

    return !!(tokenData && (tokenData.refreshToken || tokenData.refresh_token));
  } catch (error) {
    return false;
  }
}

function getValidDecodedToken() {
  const token = getStoredToken();

  if (!token) return null;

  try {
    const decoded: any = jwt(token);
    const expiresAt = decoded && decoded.exp ? Number(decoded.exp) * 1000 : null;

    if (expiresAt && expiresAt <= Date.now()) {
      if (hasStoredRefreshToken()) {
        return decoded;
      }

      localStorage.clear();
      return null;
    }

    return decoded;
  } catch (error) {
    localStorage.clear();
    return null;
  }
}

//the route guard
// Perfil de acesso (Administracao > Perfis): a rota pertence a uma area do
// catalogo e exige "ver" nela. Rota sem area (inicio, login) e livre.
const guard = async function(to: any, from: any, next: any) {
  const publicPath = to.matched.find((path) => path.name === "Public");
  const decodedToken: any = getValidDecodedToken();

  if (!decodedToken && to.path !== "/login" && !publicPath) {
    next({ path: "/login" });
    return;
  }

  if (!decodedToken || to.path === "/login" || to.name == "Home") {
    next();
    return;
  }

  try {
    await access.load();
  } catch (error) {
    // Sem o perfil (API fora ou sessao expirada): so a tela inicial.
    next({ path: "/home" });
    return;
  }

  const area = access.areaOfRoute(to.name);
  if (area && !access.can(area, "view")) {
    next({ path: "/home" });
    return;
  }

  next();
};

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    component: () => import("@/layouts/Public.vue"),
    children: [
      {
        path: "/login",
        name: "login",
        component: Login,
      },
      {
        path: "/",
        redirect: "/login",
      },
    ],
  },
  {
    path: "/",
    component: () => import("@/layouts/Private.vue"),
    beforeEnter: guard,
    children: [
      {
        path: "/home",
        name: "Home",
        component: Home,
        beforeEnter: guard,
      },
      {
        path: "/credores",
        name: "User",
        component: UserList,
        beforeEnter: guard,
      },
      {
        path: "/credores/:id",
        name: "User",
        component: UserDetails,
        beforeEnter: guard,
      },
      {
        path: "/dados-bancarios",
        name: "BankInformation",
        component: BankInformationList,
        beforeEnter: guard,
      },
      {
        path: "/admins",
        name: "Admin",
        component: AdminList,
        beforeEnter: guard,
      },
      {
        path: "/admins/:id",
        name: "Admin",
        component: AdminDetails,
        beforeEnter: guard,
      },
      {
        // Perfis de acesso: so para acesso total (area "Profiles").
        path: "/perfis",
        name: "Profiles",
        component: ProfileList,
        beforeEnter: guard,
      },
      {
        path: "/perfis/:id",
        name: "Profiles",
        component: ProfileDetails,
        beforeEnter: guard,
      },
      {
        path: "/textos-automaticos",
        name: "DynamicText",
        component: DynamicTextList,
        beforeEnter: guard,
      },
      {
        path: "/textos-automaticos/:id",
        name: "DynamicText",
        component: DynamicTextDetails,
        beforeEnter: guard,
      },
      {
        path: "/divergencias",
        name: "Event",
        component: EventList,
        beforeEnter: guard,
      },
      {
        path: "/divergencias/lote",
        name: "Event",
        component: EventBulkCreate,
        beforeEnter: guard,
      },
      {
        path: "/divergencias/:id",
        name: "Event",
        component: EventDetails,
        beforeEnter: guard,
      },
      // CHC (Certidao de Habilitacao de Credito): fila e analise, na area de Hab/Div.
      {
        path: "/chc",
        name: "Event",
        component: CreditCertificateList,
        beforeEnter: guard,
      },
      {
        path: "/chc/:id",
        name: "Event",
        component: CreditCertificateDetails,
        beforeEnter: guard,
      },
      {
        path: "/event-create",
        name: "Event",
        component: EventCreate,
        beforeEnter: guard,
      },
      {
        path: "/analise-massa",
        name: "Event",
        component: EventBulkAnalysis,
        beforeEnter: guard,
      },
      {
        path: "/modelo-documentos",
        name: "TemplateDoc",
        component: TemplateDocList,
        beforeEnter: guard,
      },
      {
        path: "/modelo-documentos/:id",
        name: "TemplateDoc",
        component: TemplateDocDetails,
        beforeEnter: guard,
      },
      {
        path: "/credenciamentos",
        name: "Accreditation",
        component: AccreditationList,
        beforeEnter: guard,
      },
      // {
      //   path: "/credenciamentos/:id",
      //   name: "accreditation",
      //   component: AccreditationDetails,
      //   beforeEnter: guard,
      // },
      {
        path: "/textos-dinamicos",
        name: "DynamicInfo",
        component: DynamicInfoList,
        beforeEnter: guard,
      },
      {
        path: "/textos-dinamicos/:id",
        name: "DynamicInfo",
        component: DynamicInfoDetails,
        beforeEnter: guard,
      },
      {
        path: "/casos",
        name: "Client",
        component: ClientList,
        beforeEnter: guard,
      },
      {
        path: "/lista-credores/incluir",
        name: "Creditors",
        component: CreditorsInclude,
        beforeEnter: guard,
      },
      {
        path: "/lista-credores",
        name: "Creditors",
        component: CreditorsList,
        beforeEnter: guard,
      },
      {
        // Importacao concluida: o que foi subido (linhas e planilha original).
        path: "/lista-credores/:id",
        name: "Creditors",
        component: CreditorsListImport,
        beforeEnter: guard,
      },
      {
        path: "/casos/:id",
        name: "Client",
        component: ClientDetails,
        beforeEnter: guard,
      },
      {
        path: "/documentos",
        name: "Document",
        component: ClientDocList,
        beforeEnter: guard,
      },
      {
        path: "/documentos/:id",
        name: "Document",
        component: ClientDocDetails,
        beforeEnter: guard,
      },
      {
        path: "/noticias",
        name: "ClientNews",
        component: ClientNewsList,
        beforeEnter: guard,
      },
      {
        path: "/faqs",
        name: "Faq",
        component: FaqList,
        beforeEnter: guard,
      },
      {
        path: "/faqs/:id",
        name: "Faq",
        component: FaqDetails,
        beforeEnter: guard,
      },
      {
        path: "/agcs",
        name: "GeneralMeeting",
        component: GeneralMeetingList,
        beforeEnter: guard,
      },
      {
        path: "/agcs-homologacoes",
        name: "GeneralMeeting",
        component: GeneralMeetingHomologations,
        beforeEnter: guard,
      },
      {
        path: "/agcs-substabelecimentos",
        name: "GeneralMeeting",
        component: GeneralMeetingSubstitutions,
        beforeEnter: guard,
      },
      {
        path: "/agcs/:id",
        name: "GeneralMeeting",
        component: GeneralMeetingDetails,
        beforeEnter: guard,
      },
      {
        path: "/agcs/:id/cenarios",
        name: "GeneralMeeting",
        component: VotingScenarios,
        beforeEnter: guard,
      },
      {
        path: "/procuradores",
        name: "Procurator",
        component: ProcuratorList,
        beforeEnter: guard,
      },
      // Procuracao modelo (antes de /procuradores/:id).
      {
        path: "/procuradores/procuracao-modelo",
        name: "Procurator",
        component: ProcurationTemplates,
        beforeEnter: guard,
      },
      {
        path: "/procuradores/:id",
        name: "Procurator",
        component: ProcuratorDetails,
        beforeEnter: guard,
      },
      // {
      //   path: "/agcs/votacao",
      //   name: "GeneralMeetingVoting",
      //   component: GeneralMeetingVoting,
      //   beforeEnter: guard,
      // },
      {
        path: "/agcs/votacao/:id",
        name: "GeneralMeeting",
        component: GeneralMeetingVoting,
        beforeEnter: guard,
      },
      {
        path: "/agcs/presenca/:id",
        name: "GeneralMeeting",
        component: GeneralMeetingPresence,
        beforeEnter: guard,
      },
      {
        path: "/votacao/:id?",
        name: "VotingDetails",
        component: VotingDetails,
        //props: (route) => ({ id: route.params.id, clientId: route.query.clientId }),
        beforeEnter: guard,
      },
      {
        path: "/votacao-lista",
        name: "VotingList",
        component: VotingList,
        beforeEnter: guard,
      },
      {
        path: "/comarcas",
        name: "District",
        component: DistrictList,
        beforeEnter: guard,
      },
      {
        path: "/comarcas/:id",
        name: "District",
        component: DistrictDetails,
        beforeEnter: guard,
      },
      {
        path: "/blog/posts",
        name: "Blog",
        component: PostList,
        beforeEnter: guard,
      },
      {
        path: "/blog/posts/:id",
        name: "Blog",
        component: PostDetails,
        beforeEnter: guard,
      },
      {
        path: "/colaboradores",
        name: "Employee",
        component: EmployeeList,
        beforeEnter: guard,
      },
      {
        path: "/colaboradores/:id",
        name: "Employee",
        component: EmployeeDetails,
        beforeEnter: guard,
      },
      {
        path: "/analise-oficio",
        name: "LetterAnalysis",
        component: LetterAnalysisList,
        beforeEnter: guard,
      },
      {
        path: "/central-analise-creditos",
        name: "CreditAnalysis",
        component: CreditAnalysisList,
        beforeEnter: guard,
      },
      {
        path: "/central-analise-creditos/analise",
        name: "CreditAnalysis",
        component: CreditAnalysisDetails,
        beforeEnter: guard,
      },
      {
        path: "/analise-oficio/:id",
        name: "LetterAnalysis",
        component: LetterAnalysisDetails,
        beforeEnter: guard,
      },
      {
        path: "/qgc",
        name: "Qgc",
        component: QgcList,
        beforeEnter: guard,
      },
      {
        path: "/qgc/:id",
        name: "Qgc",
        component: QgcDetails,
        beforeEnter: guard,
      },
      {
        path: "/processos-mais-consultados",
        name: "MostConsulted",
        component: MostConsultedList,
        beforeEnter: guard,
      },
      {
        path: "/banner-aviso",
        name: "HomeBanner",
        component: HomeBannerList,
        beforeEnter: guard,
      },
      {
        path: "/banner-aviso/:id",
        name: "HomeBanner",
        component: HomeBannerDetails,
        beforeEnter: guard,
      },
      {
        path: "/impugnacoes",
        name: "Proceedings",
        component: ProceedingList,
        beforeEnter: guard,
      },
      {
        path: "/impugnacoes/:id",
        name: "Proceedings",
        component: ProceedingDetails,
        beforeEnter: guard,
      },
      {
        path: "/outros-processos",
        name: "OtherProceedings",
        component: OtherProceedingList,
        beforeEnter: guard,
      },
      {
        path: "/outros-processos/:id",
        name: "OtherProceedings",
        component: OtherProceedingDetails,
        beforeEnter: guard,
      },
      {
        path: "/usuarios-recuperanda",
        name: "ClientAdmin",
        component: ClientAdminList,
        beforeEnter: guard,
      },
      {
        path: "/auditoria",
        name: "Audit",
        component: AuditLogList,
        beforeEnter: guard,
      },
      {
        path: "/adesao-plano",
        name: "PlanAdhesion",
        component: PlanAdhesionList,
        beforeEnter: guard,
      },
      {
        path: "/adesao-plano/:id",
        name: "PlanAdhesion",
        component: PlanAdhesionDetails,
        beforeEnter: guard,
      },
      {
        path: "/fiscalizacao-mensal",
        name: "Rma",
        component: RmaDashboard,
        beforeEnter: guard,
      },
      {
        path: "/fiscalizacao-mensal/casos/:clientId",
        name: "Rma",
        component: RmaCaseDetails,
        beforeEnter: guard,
      },
      {
        path: "/fiscalizacao-mensal/tipos",
        name: "Rma",
        component: RmaDocumentTypeList,
        beforeEnter: guard,
      },
      {
        path: "/fiscalizacao-mensal/questionario",
        name: "Rma",
        component: RmaQuestionTemplate,
        beforeEnter: guard,
      },
      // Auditoria das cobrancas por area (Contabilidade / Juridico), com PDF dos e-mails.
      {
        path: "/fiscalizacao-mensal/auditoria",
        name: "Rma",
        component: RmaAudit,
        beforeEnter: guard,
      },
      // Processo competitivo (venda de ativos com proposta lacrada)
      { path: "/processo-competitivo", redirect: "/processo-competitivo/painel" },
      { path: "/processo-competitivo/painel", name: "Competitive", component: CompetitiveDashboard, beforeEnter: guard },
      { path: "/processo-competitivo/processos", name: "Competitive", component: CompetitiveProcessList, beforeEnter: guard },
      { path: "/processo-competitivo/processos/:id", name: "Competitive", component: CompetitiveProcessDetails, beforeEnter: guard },
      { path: "/processo-competitivo/ativos", name: "Competitive", component: CompetitiveAssetList, beforeEnter: guard },
      { path: "/processo-competitivo/ativos/:id", name: "Competitive", component: CompetitiveAssetDetails, beforeEnter: guard },
      { path: "/processo-competitivo/cestas-e-lotes", name: "Competitive", component: CompetitiveGroupList, beforeEnter: guard },
      { path: "/processo-competitivo/etapas", name: "Competitive", component: CompetitiveStageList, beforeEnter: guard },
      { path: "/processo-competitivo/inscricoes", name: "Competitive", component: CompetitiveRegistrationList, beforeEnter: guard },
      { path: "/processo-competitivo/data-room", name: "Competitive", component: CompetitiveDataroom, beforeEnter: guard },
      { path: "/processo-competitivo/sessao-publica", name: "Competitive", component: CompetitivePublicSession, beforeEnter: guard },
      { path: "/processo-competitivo/homologacao", name: "Competitive", component: CompetitiveHomologation, beforeEnter: guard },
      { path: "/processo-competitivo/trilha", name: "Competitive", component: CompetitiveAuditTrail, beforeEnter: guard },
      {
        // Casos: abas A triar, Em acompanhamento (lista de sexta), Encerrados, Todos e Importacoes.
        path: "/prospeccao/casos",
        name: "Prospect",
        component: ProspectCases,
        beforeEnter: guard,
      },
      {
        // Antes de /prospeccao/casos/:id para "importacoes" nao virar id de caso.
        path: "/prospeccao/casos/importacoes/:id",
        name: "Prospect",
        component: ProspectImportDetails,
        beforeEnter: guard,
      },
      {
        path: "/prospeccao/casos/:id",
        name: "Prospect",
        component: ProspectCaseDetails,
        beforeEnter: guard,
      },
      // Enderecos antigos (captacao e pendentes viraram abas de Casos).
      { path: "/prospeccao/captacao", redirect: { path: "/prospeccao/casos", query: { aba: "importacoes" } } },
      { path: "/prospeccao/pendentes", redirect: { path: "/prospeccao/casos", query: { aba: "acompanhamento" } } },
      { path: "/prospeccao/importacoes/:id", redirect: (to) => `/prospeccao/casos/importacoes/${to.params.id}` },
      {
        path: "/prospeccao/cautelares",
        name: "Prospect",
        component: ProspectDeadlines,
        beforeEnter: guard,
      },
      {
        path: "/prospeccao/concorrencia",
        name: "Prospect",
        component: ProspectCompetition,
        beforeEnter: guard,
      },
      {
        path: "/prospeccao/ajs",
        name: "Prospect",
        component: ProspectAdministrators,
        beforeEnter: guard,
      },
      {
        path: "/prospeccao/juizes",
        name: "Prospect",
        component: ProspectJudges,
        beforeEnter: guard,
      },
      {
        path: "/prospeccao/juizes/:id",
        name: "Prospect",
        component: ProspectJudgeDetails,
        beforeEnter: guard,
      },
      {
        path: "/prospeccao/painel",
        name: "Prospect",
        component: ProspectDashboard,
        beforeEnter: guard,
      },
      {
        path: "/prospeccao/agendas",
        name: "Prospect",
        component: ProspectMeetings,
        beforeEnter: guard,
      },
      {
        path: "/prospeccao/metricas",
        name: "Prospect",
        component: ProspectMetrics,
        beforeEnter: guard,
      },
      {
        path: "/prospeccao/rota",
        name: "Prospect",
        component: ProspectTrips,
        beforeEnter: guard,
      },
      {
        path: "/prospeccao/rota/:id",
        name: "Prospect",
        component: ProspectTripEditor,
        beforeEnter: guard,
      },
      {
        path: "/prospeccao/sedes",
        name: "Prospect",
        component: ProspectOffices,
        beforeEnter: guard,
      },
      {
        path: "/emails",
        name: "EmailLog",
        component: EmailLogList,
        beforeEnter: guard,
      },
      {
        path: "/correspondencias",
        name: "Correspondence",
        component: CorrespondenceList,
        beforeEnter: guard,
      },
    ],
  },
];

const router = new VueRouter({
  base: process.env.BASE_URL,
  routes,
});

export default router;
